export default "__VITE_ASSET__DBgq$X_3__"